import { render, staticRenderFns } from "./PersonalizarPage.vue?vue&type=template&id=48c319e5&scoped=true"
import script from "./PersonalizarPage.vue?vue&type=script&lang=js"
export * from "./PersonalizarPage.vue?vue&type=script&lang=js"
import style0 from "./PersonalizarPage.vue?vue&type=style&index=0&id=48c319e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c319e5",
  null
  
)

export default component.exports